import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class HomeService {
  constructor(public http: HttpClient) {}

  getMetadataJson(url: any) {
    return this.http
      .get(url + '/cds-services', {
        observe: 'response'
      })
      .pipe(
        tap(res => {
          return res;
        })
        // catchError(this.handleError('getAllExtractionDetails', []))
      );
  }
}
